// PACKAGES
import React, { useState } from 'react'
import { Redirect, useParams, useLocation } from 'react-router-dom'
import { useContext } from 'use-context-selector'
import queryString from 'query-string'
import styled from 'styled-components'
// UI
import { Grid } from '@material-ui/core'
// SERVICES
import Postings from '../../services/postings'
import RedirectService from '../../services/redirect'
// HOOKS
import { useMountEffect } from '../../util/hooks'
// CONTEXTS
import { AppContext } from '../../contexts/AppContext'
// COMPONENTS
import Message from '../Messaging/Message'
import RedirectMessage from '../Messaging/RedirectMessage'

const AppGrid = styled(Grid)`
   {
    min-height: 100vh;
    align-items: center;
    justify-content: center;
  }
`

const parseProfileUrl = profileUrl => {
  const lastSlashIndex = profileUrl.lastIndexOf('/')
  const profileRedirectUrl = profileUrl.slice(0, lastSlashIndex + 1)
  return profileRedirectUrl
}

const ApplyRedirect = () => {
  const [actionStatus, setActionStatus] = useState('fetching')
  const [forwardParams, setForwardParams] = useState('')
  const [resolvedPostingId, setResolvedPostingId] = useState(null)
  const [, appDispatch] = useContext(AppContext)
  const { postingId } = useParams()
  const queryParams = queryString.parse(useLocation().search)

  useMountEffect(() => {
    const getPosting = async (jobId) => {
      try {
        const posting = await Postings.getPosting(jobId)

        appDispatch({ id: 'clientId', value: posting.clientId })
        appDispatch({ id: 'postingId', value: jobId })

        if (posting.isTrApplyExperience) {
          // read query params from redirect url and make sure we forward to legacy apply
          if (queryParams.redirect) {
            setForwardParams(RedirectService.getQueryParams(queryParams.redirect))
          }
          setActionStatus('redirect-arete')
        } else {
          setActionStatus('redirect-legacy')
        }
      } catch {
        setActionStatus('redirect-legacy')
      }
    }

    const resolveAndGetPosting = async () => {
      // Check if postingId is UUID (contains dashes) or numeric
      const isUUID = postingId.includes('-')

      if (isUUID) {
        try {
          const resolved = await Postings.resolvePostingUuid(postingId)
          if (resolved) {
            setResolvedPostingId(resolved.jobId)
            appDispatch({ id: 'channel', value: resolved.channel })
            await getPosting(resolved.jobId)
          } else {
            setActionStatus('redirect-legacy')
          }
        } catch {
          setActionStatus('redirect-legacy')
        }
      } else {
        setResolvedPostingId(postingId)
        await getPosting(postingId)
      }
    }

    if (queryParams.redirect) {
      const profileRedirectUrl = parseProfileUrl(queryParams.redirect)
      appDispatch({
        id: 'profileRedirectUrl',
        value: profileRedirectUrl
      })
    }

    resolveAndGetPosting()
  })

  return (
    <AppGrid container>
      <Grid item xs={3}>
        {actionStatus === 'fetching' && (
          <Message>Fetching application...</Message>
        )}

        {actionStatus === 'redirect-legacy' && <RedirectMessage />}

        {actionStatus === 'redirect-arete' && resolvedPostingId && (
          <Redirect to={`/postings/${postingId}/application${forwardParams}`} />
        )}
      </Grid>
    </AppGrid>
  )
}

export default ApplyRedirect
